
export default {
  props: {
    name: {type: String, default: ''},
    sortOrder: {type: Number, default: 0},
    sortable: {type: Boolean, default: false},
    checkbox: {type: Boolean, default: false},
    indeterminate: {type: Boolean, default: false},
    selected: {type: Boolean, default: false},
    disabled: {type: Boolean, default: false},
  },
  emits: ['change']
}
